export const CAMPAIGNS = [
  // {
  //   id: '1',
  //   name: 'Heineken 0.0 sigue confiando en el mejor conductor de México',
  //   description: <>
  //     Heineken 0.0 seguirá siendo patrocinador oficial de la carrera de Sergio “Checo” Pérez. Acabamos de renovar nuestra alianza con él, porque cuando se trata de tomar buenas decisiones dentro y fuera de la pista, Checo siempre da el ejemplo.<br />
  //     No solo es un piloto de clase mundial, también es alguien que comparte nuestros valores: compromiso, determinación y responsabilidad al volante.<br />
  //     Y aunque nos emociona seguir esta carrera juntos, hay algo que nunca cambiará y es que:<br />
  //     El mejor conductor siempre será el que, cuando maneja, no toma.
  //   </>,
  //   desktopUrl: `${AZURE_BASE_URL}/campaña-banner_desktop.webp`,
  //   mobileUrl: `${AZURE_BASE_URL}/campaña-banner_mobile.webp`,
  //   youtube: 'https://www.youtube.com/embed/5dqRRRnhho8?si=X5flMQdMztKLPpVp'
  // },
  {
    id: '2',
    name: 'El balance perfecto: 100% pura malta, sabor de calidad.',
    description: <>
      ¿Qué hace que Heineken tenga un sabor de calidad? Simple: está hecha con 100% pura malta. Sus ingredientes naturales y su máxima pureza son la clave detrás de nuestro sabor único y balanceado.<br />
      Desde 1873, nuestros maestros cerveceros han perfeccionado el arte de crear una cerveza auténtica. Utilizamos solo ingredientes naturales y un proceso de elaboración único que toma su tiempo, para que cada sorbo contenga ese sabor único que acompaña perfectamente cada momento de calidad.<br /><br />
      Un viernes con Heineken es asegurar un fin de semana de calidad.
    </>,
    desktopUrl: `${AZURE_BASE_URL}/campaña-banner-2_desktop.webp`,
    mobileUrl: `${AZURE_BASE_URL}/campaña-banner-2_mobile.webp`,
    youtube: 'https://www.youtube.com/embed/4SteFLtT_F4?si=v1t0XmdB56Xj0eYF'
  },
  {
    id: '3',
    name: 'La mejor forma de vivir Coachella fue con Heineken.',
    description: <>
      Coachella se vivió de la mejor manera con un ambiente vibrante y lleno de energía. La combinación de la mejor música, con artistas increíbles en cada escenario, y el sabor de calidad de Heineken fue simplemente perfecta para elevar cada momento a una experiencia inolvidable.<br /><br />
      ¡Una verdadera experiencia de clase un mundial!
    </>,
    desktopUrl: `${AZURE_BASE_URL}/campaña-banner-3_desktop.webp`,
    mobileUrl: `${AZURE_BASE_URL}/campaña-banner-3_mobile.webp`,
    youtube: 'https://www.youtube.com/embed/FpNoZOR1S_E?si=MFVJy18ffhheaDCC'
  },
  {
    id: '4',
    name: 'UCL Final Match Recap',
    description: <>¡La final se vivió con todo! Los ganadores disfrutaron una experiencia única, se conectaron con más fans y celebraron el fútbol como se debe.</>,
    desktopUrl: `${AZURE_BASE_URL}/campaña-banner-4_desktop.webp`,
    mobileUrl: `${AZURE_BASE_URL}/campaña-banner-4_mobile.webp`,
    slider: [
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/IMG_1-ucl.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/IMG_2-ucl.jpg`,
        alt: ''
      },
    ]
  },
  {
    id: '5',
    name: 'UCL Green Zone Recap',
    description: <>Así se vivió la Watch Party en la Green Zone de Heineken 0.0: final de la UCL, regalos y un ambiente futbolero.</>,
    desktopUrl: `${AZURE_BASE_URL}/campaña-banner-5_desktop.webp`,
    mobileUrl: `${AZURE_BASE_URL}/campaña-banner-5_mobile.webp`,
    slider: [
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/GZR-1.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/GZR-2.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/GZR-3.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/GZR-4.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/GZR-5.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/GZR-6.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/GZR-7.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/GZR-8.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/GZR-9.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/GZR-10.jpg`,
        alt: ''
      },
    ]
  },
  {
    id: '6',
    name: 'Afterwork Soho Recap',
    description: <>Revive la última edición del Afterwork By Heineken con este photodump. Los invitados disfrutaron de una fiesta increíble junto a los djs. </>,
    desktopUrl: `${AZURE_BASE_URL}/campaña-banner-6_desktop.webp`,
    mobileUrl: `${AZURE_BASE_URL}/campaña-banner-6_mobile.webp`,
    slider: [
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/PHDMP_HNKN_Aferwork_01.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/PHDMP_HNKN_Aferwork_02.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/PHDMP_HNKN_Aferwork_03.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/PHDMP_HNKN_Aferwork_04.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/PHDMP_HNKN_Aferwork_05.jpg`,
        alt: ''
      },
      {
        type: 'image',
        url: `${AZURE_BASE_URL}/PHDMP_HNKN_Aferwork_06.jpg`,
        alt: ''
      },
    ]
  },
  {
    id: '7',
    name: 'Heineken 0.0 | F1® THE MOVIE',
    description: <>100% sabor, 0.0% alcohol. #F1TheMovie #heineken00 #ahorapuedes</>,
    desktopUrl: `${AZURE_BASE_URL}/campaña-banner-7_desktop.webp`,
    mobileUrl: `${AZURE_BASE_URL}/campaña-banner-7_mobile.webp`,
    youtube: 'https://www.youtube.com/embed/cQGcqBlpfy4?si=JTmAnDRTyH6EqoNg'
  }
]